<script setup lang="ts">
import { Capacitor } from '@capacitor/core'
import { ImageLink } from '../../store/useInventory'
import { onBeforeMount, ref } from 'vue'
import TableAvatar from '../wrappers/TableAvatar.vue'
import { AllPartsModel } from '../../models/AllParts'
import { DownloadImageData } from '../../models/AllParts'
const props = withDefaults(
  defineProps<{
    imageData: ImageLink
    imageType: 'thumbnail' | 'standard'
  }>(),
  {
    imageType: 'standard',
  }
)

onBeforeMount(async () => {
  //before we mount, check if on device. If the image is not
  //saved to the device, we will initiate a download.
  //While that download is occurring, we have render placeholder
  //First, cancel check if we're on browser
  if (!Capacitor.isNativePlatform()) {
    path.value = await getPath(props.imageData)
    return
  }
  onDevice.value = await checkOnDevice()
  if (onDevice.value === false) {
    void download()
  } else {
    path.value = await getPath(props.imageData)
  }
})

const isNative = Capacitor.isNativePlatform()
const onDevice = ref(false)
const checkOnDevice = async () => {
  return await AllPartsModel().imageOnDevice(props.imageData)
}
const isDownloading = ref(false)
const download = async () => {
  isDownloading.value = true
  await AllPartsModel()
    .downloadPartImage(
      {
        id: props.imageData.id,
        name: props.imageData.name,
        link: props.imageData.link,
      },
      true
    )
    .then(async () => {
      path.value = await getPath(props.imageData)
    })

  isDownloading.value = false
  onDevice.value = await checkOnDevice()
}
const getPath = async (data: DownloadImageData) => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.convertFileSrc(await AllPartsModel().getImagePath(data))
  } else {
    return data.link
  }
}
const path = ref()
</script>
<template>
  <div>
    <template v-if="imageType == 'thumbnail'">
      <TableAvatar v-if="(isNative && onDevice && path) || !isNative" :src="path" />
    </template>
    <template v-else>
      <img v-if="(isNative && onDevice && path) || !isNative" :src="path" />
    </template>
  </div>
</template>
